import axios from "axios";

// Shared client for all VJ ERP Help Desk calls.
// Help Desk requires the x-api-token header on every /api/user/* call (incl. multipart ones).
const helpdeskApi = axios.create({
  headers: { "x-api-token": process.env.REACT_APP_HELPDESK_API_TOKEN },
});

export default helpdeskApi;
